import { positions } from '~/components/FoodPersonForm/positions';

export const positionTitle = (id: string) => {
  const personPositions = positions();
  return personPositions.find(obj => obj.id.toString() === id)?.name;
};
